import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Field } from '@app/api/types'

import { Answer, MchatState, MchatSteps } from './types'

export const INITIAL_STATE: MchatState = {
  status: 'initial',
  error: '',
  flowData: {
    currentStep: MchatSteps.Initial
  },
  questions: {
    currentQuestion: 0,
    score: 0,
    answers: []
  },
  inputData: {}
}

export const slice = createSlice({
  name: 'mchat',
  initialState: INITIAL_STATE,

  reducers: {
    setMchatStep: (state, { payload }: PayloadAction<number>) => {
      state.flowData.currentStep = payload
    },
    requestUpdateMchatInputData: state => {
      state.status = 'pending'
    },
    successUpdateMchatInputData: (state, { payload: { fieldName, fieldValue } }: PayloadAction<Field>) => {
      state.status = 'success'
      state.inputData[fieldName] = fieldValue
    },
    errorUpdateMchatInputData: (state, { payload }: PayloadAction<string>) => {
      state.status = 'failure'
      state.error = payload
    },
    setCurrentQuestion: (state, { payload }: PayloadAction<number>) => {
      state.questions.currentQuestion = payload
    },
    addAnswer: (state, { payload }: PayloadAction<Answer>) => {
      state.questions.answers = [...state.questions.answers, payload]
    },
    setScore: (state, { payload }: PayloadAction<number>) => {
      state.questions.score = payload
    },
    requestMchatCompleted: state => {
      state.status = 'pending'
    },
    successMchatCompleted: state => {
      state.status = 'success'
    },
    errorMchatCompleted: (state, { payload }: PayloadAction<string>) => {
      state.status = 'failure'
      state.error = payload
    }
  }
})

export const { actions } = slice
export const mchatReducer = slice.reducer
